import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-hierarchy',
  templateUrl: './employee-hierarchy.component.html',
  styleUrls: ['./employee-hierarchy.component.scss']
})
export class EmployeeHierarchyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
